import type { Image as ImageType } from 'types/capi/shared';

import Image from '~/components/Image';

type Props = {
  image: ImageType;
  index: number;
  pad: boolean;
  setCurrentSlide: Function;
};

const ImageThumb = ({ setCurrentSlide, image, index, pad }: Props) => {
  const imageClassNames = 'rounded-xl w-20 h-20 block bg-concrete';

  return (
    <button
      key={index}
      onClick={() => setCurrentSlide(index)}
      className={`shadow-sm ring-1 ring-concrete transition-all duration-100 ease-in-out hover:shadow-md ${imageClassNames}`}
    >
      <Image
        className={imageClassNames}
        loading="eager"
        pad={pad}
        src={image.url}
        alt={image.alt}
        height={400}
        width={400}
        responsiveOptions={{
          lg: { height: 400, pad, width: 400 },
          md: { height: 400, pad, width: 400 },
          sm: { height: 400, pad, width: 400 },
          xl: { height: 400, pad, width: 400 }
        }}
      />
    </button>
  );
};

export default ImageThumb;
